import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './doqfy-components/dashboard/dashboard.component';
import { LandingPageComponent } from './doqfy-components/landing-page/landing-page.component';
import { SharedComponentsModule } from './shared-components/shared-components.module';
import { CookieService } from 'ngx-cookie-service';
import { LayoutModule } from './layout/layout.module';
import { ChartComponent } from './doqfy-components/dashboard/chart/chart.component';
import { FrequentlyUsedComponent } from './doqfy-components/dashboard/frequently-used/frequently-used.component';
import { SideNavComponent } from './doqfy-components/dashboard/side-nav/side-nav.component';
import { OrderDashboardComponent } from './doqfy-components/dashboard/order-dashboard/order-dashboard.component';
import { ViewAllOrderDetailsComponent } from './doqfy-components/view-all-order-details/view-all-order-details.component';
import { ReventActivityListComponent } from './doqfy-components/view-all-order-details/revent-activity-list/revent-activity-list.component';
import { OrderDetailsDashboardComponent } from './doqfy-components/view-all-order-details/order-details-dashboard/order-details-dashboard.component';
import { AdminFrequentlyUsedComponent } from './doqfy-components/admin-dashboard/admin-frequently-used/admin-frequently-used.component';
import { AdminDashboardComponent } from './doqfy-components/admin-dashboard/admin-dashboard.component';
import { AdminSideNavComponent } from './doqfy-components/admin-dashboard/admin-side-nav/admin-side-nav.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpAuthInterceptor } from './services/http-auth.interceptor';
import { StorageService } from './services/storage.service';
import { PdfjsWorkerBootstrapService } from './services/pdfjs-worker-bootstrap.service';
import { HttpLoaderInterceptor } from './services/http-loader.interceptor';
import { LoaderComponent } from './doqfy-components/loader/loader.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgIdleModule } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { WebcamModule } from 'ngx-webcam';
import { SignLinkComponent } from './sign-link/sign-link.component';
import { KycDetailsComponent } from './kyc-details/kyc-details.component';
import { AadhaarLinkComponent } from './sign-link/aadhaar-link/aadhaar-link.component';
import { AadhaarResponseComponent } from './sign-link/aadhaar-response/aadhaar-response.component';
import { DatePipe } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
import { DscResponseComponent } from './sign-link/dsc-response/dsc-response.component';
import { RazorPayComponent } from './sign-link/razor-pay/razor-pay.component';
import { AccordionModule } from 'primeng/accordion';
import { ServiceWorkerModule } from '@angular/service-worker';
//implementing msal of angular 11
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { BulkResultComponent } from './bulk-result/bulk-result.component';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { ListboxModule } from 'primeng/listbox';
import { UpdateService } from './services/update.service';
import { RazorpayTransactionComponent } from './doqfy-components/razorpay-transaction/razorpay-transaction/razorpay-transaction.component';
import { SignFailedComponent } from './sign-link/sign-failed/sign-failed.component';
import { CyberarkComponent } from './cyberark/cyberark.component';
import { UploadProgressPopupComponent } from './upload-progress-popup/upload-progress-popup.component';
import { SecondVersionEsignComponent } from './sign-link/second-version-esign/second-version-esign.component';
import { SelectModule } from 'primeng/select';
import { AadhaarSignComponent } from './sign-link/second-version-esign/aadhaar-sign/aadhaar-sign.component';
import { ElectronicSignComponent } from './sign-link/second-version-esign/electronic-sign/electronic-sign.component';
import { HdfcCallbackComponent } from './sign-link/hdfc-callback/hdfc-callback.component';
import { JuspayCallbackComponent } from './sign-link/juspay-callback/juspay-callback.component';
import { ShareSignLinkComponent } from './sign-link/share-sign-link/share-sign-link.component';
import { ShareSignLinkDetailsComponent } from './sign-link/share-sign-link/share-sign-link-details/share-sign-link-details.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DocxToHtmlConverterComponent } from './doqfy-components/docx-to-html-converter/docx-to-html-converter.component';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const DoqfyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50:  '{violet.50}',
      100: '{violet.100}',
      200: '{violet.200}',
      300: '{violet.300}',
      400: '{violet.400}',
      500: '{violet.500}',
      600: '{violet.600}',
      700: '{violet.700}',
      800: '{violet.800}',
      900: '{violet.900}',
      950: '{violet.950}',
    },
  },
});
import { inject, provideAppInitializer } from '@angular/core';
import { CoreModule } from './core/core.module';
import { TenantService } from './core/services/tenant.service';
import { ThemeService } from './core/services/theme.service';
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;


export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId, // PPE testing environment
      authority: environment.msalConfig.auth.authority, // Prod environment. Uncomment to use.
      redirectUri: environment.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.apiConfig.uri,
    environment.apiConfig.scopes,
  ); // Prod environment. Uncomment to use.

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.apiConfig.scopes,
    },
    loginFailedRoute: environment.msalConfig.auth.loginFailedRoute,
  };
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LandingPageComponent,
    ChartComponent,
    SideNavComponent,
    FrequentlyUsedComponent,
    OrderDashboardComponent,
    ViewAllOrderDetailsComponent,
    ReventActivityListComponent,
    OrderDetailsDashboardComponent,
    AdminFrequentlyUsedComponent,
    AdminDashboardComponent,
    AdminSideNavComponent,
    LoaderComponent,
    SignLinkComponent,
    KycDetailsComponent,
    AadhaarLinkComponent,
    AadhaarResponseComponent,
    RazorPayComponent,
    DscResponseComponent,
    BulkResultComponent,
    SignFailedComponent,
    CyberarkComponent,
    UploadProgressPopupComponent,
    SecondVersionEsignComponent,
    AadhaarSignComponent,
    ElectronicSignComponent,
    HdfcCallbackComponent,
    JuspayCallbackComponent,
    ShareSignLinkComponent,
    ShareSignLinkDetailsComponent,
    NotFoundComponent,
    DocxToHtmlConverterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    SharedComponentsModule,
    LayoutModule,
    NgbModule,
    NgxSpinnerModule,
    WebcamModule,
    NgOtpInputModule,
    AccordionModule,
    NgIdleModule.forRoot(),
    MsalModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production || (environment as any).serviceWorkerEnabled,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    DialogModule,
    CardModule,
    ListboxModule,
    ButtonModule,
    DynamicDialogModule,
    SelectModule,
    TranslateModule.forRoot({ defaultLanguage: 'en' }),
  ],
  // All the node modules should be added we use for commen should be added in SharedComponentsModule

  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    CookieService,
    StorageService,
    Keepalive,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DialogService,
    UpdateService,
    providePrimeNG({ theme: { preset: DoqfyPreset } }),
    provideAppInitializer(() => {
      const tenantService = inject(TenantService);
      const themeService = inject(ThemeService);
      const config = tenantService.loadConfig();
      themeService.applyTheme(config.theme);
    }),
    provideAppInitializer(() => {
      const pdfjsWorkerBootstrap = inject(PdfjsWorkerBootstrapService);
      return pdfjsWorkerBootstrap.ready;
    }),
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  exports: [UploadProgressPopupComponent],
})
export class AppModule {}
